<!-- <div style="background: url(../../assets/images/bg.jpg) no-repeat; background-size: cover; height: 100vh;"> -->
<div class="container" *ngIf="isShowLogin">
    <div class="in_right">
    </div>
    <div class="box-left">
        <div class="logo">
            <img src="../../assets/images/Logo.png" style="height: 50px;"/>

            <header>SIGN IN</header>
        </div>
        <div class="in_left">
            
            <form name="form" (ngSubmit)="f.form.valid && onLogin()" #f="ngForm" novalidate>
            <input type="text" id="txtSignUp" name="userID" class="form-control" style="font-family: FontAwesome;" placeholder="&#xf1fa; Email ID"
            [(ngModel)]="loginModel.userID" #userID="ngModel" [ngClass]="{ 'is-invalid': f.submitted && userID.invalid }" required/>
            <div *ngIf="f.submitted && userID.invalid" class="invalid-feedback">
                <div *ngIf="userID.errors.required" style="font-size: 15px;">*UserID is required</div>
            </div> 
            <small></small>
            <input type="password" id="txtSignUp" name="password" class="form-control" style="font-family: FontAwesome;" placeholder="&#xf084; Enter Password" 
            [(ngModel)]="loginModel.password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required/>
            <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                <div *ngIf="password.errors.required" style="font-size: 15px;">*Password is required</div>
            </div>
            <small></small>
            <button type="submit" class="btn btn-success btn-lg" style="font-size: 16px; font-weight: 500; line-height: 20px; background-color: #004526; border:none;margin-top: 17px;"><i class="fas fa-paper-plane" aria-hidden="true" style="color: #fff;"></i> &nbsp;Sign In</button>

           </form>
        </div>
        <p class="fg" (click)="showForgetPassword()">Forgot password?</p>

        <p class="anotherLogin" style="margin-top: 40px;padding: 0 29px;">Login With &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <img src="/assets/images/google.png" style="height: 35px;" alt="go">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="/assets/images/fb.png" style="height: 35px;" alt="face"></p>

    </div>
    <div class="in_right">
    </div>
    <div class="box-right">   
    </div>
    
    <span>
    <span style="font-size: 22px;font-weight: 500;color: #004526;cursor: pointer;" (click)="showSignUp()"> Sign Up,</span><span style="font-size: 18px;font-weight: 400;color: #004526;">If new here!</span>  </span>

</div> 
<div class="container" *ngIf="isShowForgetPassword">
    <div class="in_right">
    </div>
    <div class="box-left">
        <div class="logo">
            <img src="../../assets/images/Logo.png" style="height: 50px;"/>
            <!-- <i class="far fa-user"></i> -->
            <header>Forget Password</header>
        </div>
        <div class="in_left">
            
            <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>

            <input type="text" id="txtSignUp" name="email" style="font-family: FontAwesome;" placeholder="&#xf1fa; Email ID" 
            [(ngModel)]="loginModel.email" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email/>
            <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                <div *ngIf="email.errors.required" style="font-size: 15px;">*Email is required</div>
                <div *ngIf="email.errors.email" style="font-size: 18px;">*Email must be a valid email address</div>
            </div>
            <small></small>
            <!-- <input type="password" name="password" style="font-family: FontAwesome;" placeholder="&#xf084; Enter Password" [(ngModel)]="loginUserData.password"/>
      
            <small></small> -->
            
           

            <!-- <input type="button" value="LOGIN" (click)="onLogin()" style="color:aliceblue" /> -->
            <button type="submit" class="btn btn-success btn-lg" style="font-size: 16px; font-weight: 500; line-height: 20px; background-color: #004526; border:none;margin-top: 17px;border-radius: 15px;width: 80%;height: 50px;;"><i class="fas fa-paper-plane" aria-hidden="true" style="color: #fff;"></i> &nbsp;Reset Password</button>
        </form>

        </div>
        <!-- <p class="fg">Forgot password?</p> -->

        <!-- <p class="anotherLogin" style="margin-top: 40px;padding: 0 35px;">Login With &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <img src="/assets/images/google.png" style="height: 35px;" alt="go">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="/assets/images/fb.png" style="height: 35px;" alt="face"></p> -->

    </div>
   
    <div class="in_right">
    </div>
    <div class="box-right"> 
    </div>

    <span>
    <span style="font-size: 22px;font-weight: 500;color: #004526;cursor: pointer;" (click)="showSignUp()"> Sign In</span><span style="font-size: 18px;font-weight: 400;color: #004526;"></span>  </span>

   </div> 

     
   <div class="loading-overlay">

    <span class="fa fa-spinner fa-spin" style="font-size:40px"></span>
</div>

   
  <div class="container" *ngIf="isShowSignUp">
    <div class="in_right">
    </div>
    <div class="box-left">
        <div class="logo">
            <img src="../../assets/images/Logo.png" style="height: 50px;"/>         
            <header>SIGN UP</header>
        </div>
        <div class="in_left">
            <form name="form" (ngSubmit)="f.form.valid && onSendOtp()" #f="ngForm" novalidate>
            <input type="text" id="txtSignUp" name="name" class="form-control" style="font-family: FontAwesome;" placeholder="&#xf007;  Enter name"
            [(ngModel)]="signUpModel.name" #name="ngModel" [ngClass]="{ 'is-invalid': f.submitted && name.invalid }" required/>
            <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                <!-- <div *ngIf="name.errors.required" style="font-size: 15px;">*Name is required</div> -->
            </div>       
            <small></small>
            <input type="text" id="txtSignUp" name="email" class="form-control" style="font-family: FontAwesome;" placeholder="&#xf0e0; Enter  email"
            [(ngModel)]="signUpModel.email" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email />
            <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                <!-- <div *ngIf="email.errors.required" style="font-size: 15px;">*Email is required</div> -->
                <div *ngIf="email.errors.email" style="font-size: 18px;">*Email must be a valid email address</div>
            </div>            
            <small></small>
            <input type="text" id="txtSignUp" name="mobileNo" class="form-control" style="font-family: FontAwesome;" placeholder="&#xf098; Enter mobile no" 
            [(ngModel)]="signUpModel.mobileNo" #mobileNo="ngModel" [ngClass]="{ 'is-invalid': f.submitted && mobileNo.invalid }" required />
            <div *ngIf="f.submitted && mobileNo.invalid" class="invalid-feedback">
                <!-- <div *ngIf="mobileNo.errors.required" style="font-size: 15px;">*Mobile Number is required</div> -->
            </div>           
            <small></small>
            <input type="password" id="txtSignUp" name="password" class="form-control" style="font-family: FontAwesome;" placeholder="&#xf084; Enter password" 
            [(ngModel)]="signUpModel.password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required />
            <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                <!-- <div *ngIf="password.errors.required" style="font-size: 15px;">*Password is required</div> -->
            </div>
            <small></small>          
            <button type="submit" class="btn btn-success btn-lg" style="font-size: 16px; font-weight: 500; line-height: 20px; background-color: #004526; border:none;margin-top: 17px;"><i class="fas fa-paper-plane" aria-hidden="true" style="color: #fff;"></i> &nbsp;Sign Up</button>
            </form>
        </div>
        
    </div>  
    <div class="in_right">
    </div>
    <div class="box-right"> 
    </div>
    <span>
    <span style="font-size: 22px;font-weight: 500;color: #004526;cursor: pointer;" (click)="showLogin()"> Sign In, </span><span style="font-size: 18px;font-weight: 400;color: #004526;"> Already have an account</span>  </span>

   </div> 


  <div class="container" *ngIf="isShowOtp">
    <div class="in_right">
    </div>
    <div class="box-otp">
        <div class="logo">
            <img src="../../assets/images/Logo.png" style="height: 90px;"/>
            <header style="margin-top: 38px;font-size: 30px;font-weight: 600;color: #363636;margin-left: 65px;margin-bottom: 42px;">OTP Verification</header>
        </div>
        <div class="in_left">
            <span style="margin: 33px auto;">
                <span style="color: #58545c;font-size: 20px;font-weight: 500;">Enter the OTP sent to </span><span style="color: #004526;font-weight: 600;font-size: 20px;"> +91-{{signUpModel.mobileNo}}</span>
            </span>

            <form name="form" (ngSubmit)="f.form.valid && onSignUp()" #f="ngForm" novalidate>
            <span>
                <input type="text" id="partitioned" name="otp" maxlength="4" 
                [(ngModel)]="signUpModel.otp" #otp="ngModel" [ngClass]="{ 'is-invalid': f.submitted && otp.invalid }" required />
                <div *ngIf="f.submitted && otp.invalid" class="invalid-feedback">
                    <div *ngIf="otp.errors.required" style="font-size: 15px;">*OTP is required</div>
                </div>
            <small></small>
        </span>
      <br>
      <br>
             <span>
                <span style="color: #58545c;font-size: 20px;font-weight: 400;">Dont Recieve OTP? </span><span style="color: #004526;font-weight: 600;font-size: 20px;cursor: pointer;" (click)="resendOtp()"> RESEND  OTP</span>
            </span>
            <br>
          
            <button type="submit" class="btn btn-success btn-lg" 
            style="font-size: 16px; font-weight: 500; line-height: 20px; background-color: #004526; border:none;margin-top: 35px;width: 80%;height: 50px;border-radius: 15px;box-shadow: 6px 7px 30px -6px #004526;"> &nbsp;
            
            VERIFY & PROCEED
        </button>

      </form>
        </div>
        
    </div>
   
    <div class="in_right">
    </div>
    <div class="box-right-otp">
     
        
    </div>
    
   </div> 
<!-- </div> -->
